import * as React from 'react';
import { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useQuery } from 'react-query';
import Avatar from '@mui/material/Avatar';
import apiClient from '../../request/http-common';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { Link as RouterLink } from 'react-router-dom';
import Slide from '@mui/material/Slide';
import { useMutation } from "react-query";


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Box from '@mui/material/Box';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function WithdrawalList() {
  const formatPrice = (amount, currency)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

    const [withdrawals, setwithdrawals] = useState(null);
    const { isLoading: isLoadingwithdrawals, refetch: getwithdrawals } = useQuery(
        "list-withdrawals",
        async () => {
          return await apiClient.get("/api/list-withdrawals");
        },
        {
          enabled: false,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
                setwithdrawals(res.data.withdrawals);
                const event2 = new Event('processed');
                window.dispatchEvent(event2);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
    
      useEffect(() => {
        getwithdrawals() 
        if (isLoadingwithdrawals) {
            const event3 = new Event('processing');
            window.dispatchEvent(event3);
        }
      }, []);

      const [open2, setOpen2] = React.useState(false);
      const [withdrawalId, setwithdrawalId] = useState('');
      const [withdrawalStatus, setwithdrawalStatus] = useState('');

      const handleClose2 = () => {
        setOpen2(false);
      };
      const handleToggle2 = () => {
        setOpen2(!open2);
      };


      const { isLoading: isUpdating, mutate: updatewithdrawal } = useMutation(
        async () => {
          return await apiClient.post(`/api/update-withdrawal`, {
            withdrawal_id: withdrawalId,
            withdrawal_status: withdrawalStatus,
          });
          
        },
        {
          onSuccess: (res) => {
              if (res.data.status === 'success') {
      
                localStorage.setItem('notification', JSON.stringify({message : `${res.data.message}`, 'type': 'success' }));
                setTimeout(() => {
                  const event = new Event('newMessage');
                  window.dispatchEvent(event);
                }, 1000);
      
                const event2 = new Event('processed');
                window.dispatchEvent(event2);                
                
              }            
          },
          onError: (err) => {
            let errorMessage = err.response?.data || err ;
            localStorage.setItem('notification', JSON.stringify({message : `${errorMessage.message}`, 'type': 'error' }));
            const event = new Event('newMessage');
            window.dispatchEvent(event);
            const event4 = new Event('processed');
            window.dispatchEvent(event4);
            
          },
        }
      );


  const getDate = (date) => new Date(date).toDateString();

  // Delete Withdrawal functionality
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteWithdrawalId, setDeleteWithdrawalId] = useState(null);

  const { isLoading: isDeletingWithdrawal, mutate: deleteWithdrawal } = useMutation(
    async () => {
      return await apiClient.post(`/api/delete-withdrawal`, {
        id: deleteWithdrawalId
      });
    },
    {
      onSuccess: (res) => {
        if (res.data.status === 'success') {
          localStorage.setItem('notification', JSON.stringify({message: res.data.message, type: 'success'}));
          const event = new Event('newMessage');
          window.dispatchEvent(event);
          getwithdrawals();
          setDeleteDialogOpen(false);
        }
      },
      onError: (err) => {
        localStorage.setItem('notification', JSON.stringify({message: err.response?.data?.message || 'Error deleting withdrawal', type: 'error'}));
        const event = new Event('newMessage');
        window.dispatchEvent(event);
        setDeleteDialogOpen(false);
      }
    }
  );

  const handleDeleteClick = (id) => {
    setDeleteWithdrawalId(id);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    deleteWithdrawal();
  };
  return (
    <div style={{marginTop: '75px'}}>
    <Container>
        <Typography  mt={4} mb={2} sx={{ fontWeight: 'bold', fontSize: 20, textAlign: 'center', textTransform: 'uppercase' }} gutterBottom variant="h6" component="div">
        
        {isLoadingwithdrawals ? 'Loading...' : 'List of Withdrawals'}
      </Typography>
    <TableContainer component={Paper}>
        
      {withdrawals !== null &&
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
      <TableHead>
        <TableRow>
        
        <TableCell>User Name</TableCell>
          <TableCell align="right">User Email</TableCell>
          <TableCell align="right">Amount</TableCell>
          <TableCell align="right">Coin</TableCell>
          <TableCell align="right">Address</TableCell>

          <TableCell align="right">Status</TableCell>
          <TableCell align="right">Withdrawal Source</TableCell>
          <TableCell align="right">Edit</TableCell>
          <TableCell align="right">Update Status</TableCell>
          <TableCell align="right">Delete</TableCell>
          <TableCell align="right">Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {withdrawals.map((withdrawal) => (
          <TableRow
            key={withdrawal.id}
            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
          >
            <TableCell component="th" scope="row">
            {withdrawal.user.name}
            </TableCell>
            <TableCell align="right">{withdrawal.user.email}</TableCell>
            <TableCell align="right">{formatPrice(withdrawal.amount, withdrawal.user.currency)}</TableCell>
            <TableCell align="right">{withdrawal.coin_name}</TableCell>
            <TableCell align="right">{withdrawal.address}</TableCell>
            <TableCell align="right">{withdrawal.status}</TableCell>
            <TableCell align="right">{withdrawal.source}</TableCell>
            <TableCell align="right"><Button component={RouterLink} to={`/edit-withdrawal/${withdrawal.id}`} startIcon={<EditIcon />}>Edit</Button></TableCell>
            <TableCell align="right"><Button
            onClick={() =>{handleToggle2(); setwithdrawalId(withdrawal.id);}} 
             startIcon={<EditIcon />}>Update Status</Button></TableCell>
            <TableCell align="right"><IconButton size="small" color="error" onClick={() => handleDeleteClick(withdrawal.id)}><DeleteIcon /></IconButton></TableCell>
            <TableCell align="right">{getDate(withdrawal.created_at)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
      }
      
    </TableContainer>
    </Container>

    <Dialog
        
        open={open2}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose2}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle sx={{textAlign: 'center'}}>{"UPDATE STATUS"}</DialogTitle>
        <DialogContent>
          <Box px={1} sx={{display: 'flex', justifyContent: 'space-evenly'}}>

          <FormControl fullWidth={true} sx={{ m: 1, minWidth: 50 }}>
            <InputLabel htmlFor="status">status</InputLabel>
                <Select
                    onChange={(e) => setwithdrawalStatus(e.target.value)}
                    labelId="status"
                    id="status"
                    name="status"
                    label='status'
                    >
                    <MenuItem selected value=''>
                        select status
                    </MenuItem> 
                    <MenuItem value="pending">pending</MenuItem>
                    <MenuItem value="approved">Approved</MenuItem>
                    <MenuItem value="declined">Declined</MenuItem>
                </Select>
            </FormControl>
          </Box>          
        </DialogContent>
        
        <DialogActions>
            <Button onClick={()=>updatewithdrawal()} color='error'>{isUpdating? 'Updating...': 'Update Status'}</Button>
        </DialogActions>
      </Dialog>

    {/* Delete Confirmation Dialog */}
    <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to delete this withdrawal? This action cannot be undone.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
        <Button onClick={handleDeleteConfirm} color="error" variant="contained" disabled={isDeletingWithdrawal}>
          {isDeletingWithdrawal ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>

    </div>
  );
}